export default __webpack_public_path__ + "static/media/welcome-1.328833d9.png";